import { useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { OrganizationForm } from '@/features/onboarding/components/organization-form'

export function CreateOrganizationDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  const navigate = useNavigate()
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create a new organization</DialogTitle>
          <DialogDescription>Organizations have their own displays, content, team and subscription.</DialogDescription>
        </DialogHeader>
        <OrganizationForm
          onCreated={(tenant) => {
            onOpenChange(false)
            toast.success(`${tenant.name} created`, { description: 'Let’s finish setting it up.' })
            void navigate({ to: '/onboarding' })
          }}
        />
      </DialogContent>
    </Dialog>
  )
}
